import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { movewareJobId } from "./movewareJobDisplay";

export default function MovewareJobIdCell({ item }) {
  const jobId = movewareJobId(item);

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.4 }}>
        Job ID:
      </Typography>
      <Typography variant="body2" sx={{ lineHeight: 1.4 }}>
        {jobId || "—"}
      </Typography>
    </Box>
  );
}
